export const roomMessageMap = (response, currentUserId) => {
  return response.map(message => ({
    type: Number(message.sender_id) === Number(currentUserId) ? "sent" : "received",
    payload: {
      text: message.message,
      senderId: message.sender_id,
      senderName: message.username || "Unknown",
      timestamp: message.time ? formatMessageTime(message.time) : "Now",
    }
  }));
}
export const privateMessageMap = (messageData, currentUserId, userName) => {
  return messageData.map(message => ({
    type: message.kind === 'call' ? 'call' : (Number(message.userId) === Number(currentUserId) ? "sent" : "received"),
    payload: {
      text: message.message,
      senderId: message.senderId,
      senderName: userName || "Unknown",
      timestamp: message.timestamp ? formatMessageTime(message.timestamp) : "Now",
      kind: message.kind || '',
      callId: message.callId || '',
    }
  }));
}


export const formatMessageTime = (utcTimestamp) => {
  const messageDate = new Date(utcTimestamp);
  const now = new Date();

  const isToday = messageDate.toDateString() === now.toDateString();
  const isYesterday = messageDate.toDateString() === new Date(now - 86400000).toDateString();

  if (isToday) {
    // Display time with AM/PM format
    return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
  } else if (isYesterday) {
    return "Yesterday";
  } else {
    // Display date for older messages
    return messageDate.toLocaleDateString();
  }
}

export const getEmojiList = () => {
  return [
    "😀", "😄", "😁", "😆", "😅", "😂", "🤣", "😊", "😃",
    "😍", "🥰", "😘", "😋", "😎", "🤩", "😏", "😜", "🤪",
    "😝", "🤑", "🤗", "🤭", "🤔", "🤫", "😬", "🙄", "😑",
    "😴", "😷", "🤒", "🤕", "🤢", "🤮", "🥵", "🥶", "🥴",
    "😵", "🤯", "🤠", "🥳", "🤓", "🧐", "🥺", "😇", "😙",
    "😗", "😚", "🙂", "🙃", "😉", "😌", "🤥", "🤨", "😐",
    "😔", "😪", "🤤", "🫠", "🫥", "🫡", "🫢", "🫣", "🫨"
  ];
};
